const getOptionPaymentMethod = (t) => [
    {
        name: t('card'),
        forBack: 'CARD'
    },
    {
        name: t('cash'),
        forBack: 'CASH'
    },
    {
        name: t('bank-transfer'),
        forBack: 'BANK_TRANSFER'
    },
    {
        name: t('other'),
        forBack: 'OTHER'
    },
]

export {
    getOptionPaymentMethod
}

